import { render, staticRenderFns } from "./PersonalBalanceIncomeAssets.vue?vue&type=template&id=f94c00aa"
import script from "./PersonalBalanceIncomeAssets.vue?vue&type=script&lang=js"
export * from "./PersonalBalanceIncomeAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports